import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Form, InputNumber, Switch, Typography} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";
const { Title } = Typography;


const DashboardSettingsForm = () => {
    const notify = useNotify()
    const [form] = Form.useForm();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider()
    const settingsName = "DashboardSettings"

    const {loaded, error, data: currentSettings} = useQuery({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    return (
        <>
            {
                (loaded || error) &&
                <Form form={form}
                    labelAlign='left'
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    <Form.Item
                        name="rolling_average_window"
                        label="Rolling Average Window"
                        initialValue={currentSettings?.['config']?.rolling_average_window || 3}
                        rules={[{
                            type: "number",
                            min: 1,
                            message: "Window must be at least 1"
                        }]}
                    >
                        <InputNumber
                            style={{ width: "100%", borderRadius: 6 }}
                            min={1}
                            placeholder="Enter rolling average window (e.g., 3 for 3-day-period average)"
                        />
                    </Form.Item>

                </Form>
            }
        </>
    )
}

export default DashboardSettingsForm;